<template>

    <div class="all">

        <div class="isloginTips" v-show="loadingShow">
            <img src="@/assets/loading.png" alt="">
            <p>提交中...</p>
        </div>
        <!--mescroll滚动区域的基本结构-->
        <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit">
        <div style="padding:0 12px">
        <!-- 网络异常tips -->
        <div class="tips" v-show="this.$store.state.tips"><span>网络异常！请检查网络设置或下拉刷新</span></div>

        <!-- faq预付款盒子 -->
        <div class="faq" v-show="faqshow">
            <div class="faq-title">预付款比例</div>
            <div class="faq-content">
                <p>预付款比例≤30%会强平<br>预付款比例=净值/已用预付款*100%</p>
            </div>
            <div @click="removefaq" class="faq-bottom">我知道了</div>
        </div>

        <div class="card-box">
            <div v-for="(account,index) of accountInfoArr" :key="index" class="card" :class="getchicang>0?'cardactived':(getchicang==0?'cardactived0':'card')">
                <div class="title">
                    <span>
                    账户净值（美元）
                    <img v-show="eyeshow" @click="showeyes" class="openeyes" src="@/assets/openeyes.png" alt="">
                    <img v-show="!eyeshow" @click="showeyes" class="closeeyes" src="@/assets/closeeyes.png" alt="">
                    </span><span>持仓盈亏</span></div>
                <div class="data">
                    <span v-show="eyeshow">{{getjz}}</span>
                        <span v-show="!eyeshow">*****</span>
                        <span v-show="eyeshow">{{getchicang}}</span>
                            <span v-show="!eyeshow">*****</span>
                    </div>
                <ul>
                    
                    <div class="card-left" style="display:flex;flex-direction: column;">
                        <li>
                            
                            <div class="left"><span>可用预付款</span></div>
                            <div class="right">
                                <span v-show="eyeshow">{{getyfk}}</span>
                                <span v-show="!eyeshow">*****</span>
                            </div>
                        </li>
                        
                        <li>
                            <div class="left"><span>已用预付款</span></div>
                            <div class="right">
                                <span v-show="eyeshow">{{account.AccountMargin.toFixed(2)}}</span>
                                <span v-show="!eyeshow">*****</span>
                            </div>
                        </li>
                    </div>
                    <div class="card-right" style="display:flex;flex-direction: column;">
                        <li>
                            <div class="left"><span>预付款比例<img @click="handlefaq()" style="width: 16px;height: 16px;display: block;" src="@/assets/faq-icon02.png" alt=""></span></div>
                            <div class="right">
                                <span v-show="eyeshow">{{getchicang && hasmsg?getbili+'%':'--.--'}}</span>
                                <span v-show="!eyeshow">*****</span>
                            </div>
                        </li>
                        <li>
                            <div class="left"><span>账户余额</span></div>
                            <div class="right">                            
                                <span v-show="eyeshow">{{account.AccountBalance.toFixed(2)}}</span>
                                <span v-show="!eyeshow">*****</span>
                            </div>
                        </li>
                    </div>
                </ul>
            </div>
            <div class="card-nav">
                <div><img src="@/assets/in.png" alt="">转入</div>
                <div><img src="@/assets/out.png" alt="">转出</div>
                <div><img src="@/assets/record.png" alt="">转账记录</div>
                <div><img src="@/assets/analyze.png" alt="">账户分析</div>
            </div>
        </div>
        <div class="deal" v-show="hasmsg">
            <ul>
                <li>
                    <p>买入 <span>{{getBuyLots}}</span> 手</p>
                    <p :style="{color:getbuyprofit>0?'#FF4F36':(getbuyprofit<0?'#17CF84':'#999999')}">{{getbuyprofit}}</p>
                    <button class="firbtn" :disabled="getbuyprofit == 0" style="background-color:#FFEDEA;color:#FF4F36" @click="handlePc('buyPingShow')">平仓买单</button>
                </li>
                <li>
                    <p>卖出 <span>{{getSellLots}}</span> 手</p>
                    <p :style="{color:getsellprofit>0?'#FF4F36':(getsellprofit<0?'#17CF84':'#999999')}">{{getsellprofit}}</p>
                    <button class="secbtn" :disabled="getsellprofit == 0" @click="handlePc('sellPingShow')">平仓卖单</button>
                </li>
                <li>
                    <p>合计 <span>{{getTotalLots}}</span> 手</p>
                    <p :style="{color:getTotalprofit>0?'#FF4F36':(getTotalprofit<0?'#17CF84':'#999999')}">{{(this.$store.state.goldSell || this.$store.state.silverSell) > 0?getTotalprofit.toFixed(2):'--.--'}}</p>
                    <button class="thirdbtn" :disabled="getTotalprofit == 0" @click="handlePc('allPingShow')">一键全平</button>
                </li>
            </ul>
        </div>
        <div class="nomsg" v-show="!hasmsg">
            <img src="@/assets/nomsg.png" alt="">
            暂无持仓订单
            <router-link to="/deal" style="text-decoration:none">
                <p>去交易</p>
            </router-link>
        </div>
        <div ref="directrecordwp" class="list-box" v-show="hasmsg">
            <div class="list" v-for="(item,index) of arrlist" :key="index">
                <div class="list-item">
                    <div class="title">
                        <div class="title-left">
                            <p :style="{backgroundColor:item.orderDirection == 0?'#FF4F36':(item.orderDirection == 1?'#17CF84':'')}">{{item.orderDirection == 0?'买入':(item.orderDirection == 1?'卖出':'')}}</p>
                            <p>{{item.symbol == 'XAU' || item.symbol == 'GOLD'?'伦敦金':(item.symbol == 'XAG' || item.symbol == 'SILVER'?'伦敦银':'美元')}}</p>
                            <p>{{item.lots.toFixed(2)}}手</p>
                        </div>
                        <div class="title-time" @click="handleicon(index)"><span>{{getTime(item.openTime)}}</span><img  ref="mainShows"  src="@/assets/icon-down2.png" alt=""></div>
                    </div>
                    <div class="water-mark" v-show="mnwatermark">模拟</div>

                        <div class="num" ref="mainShow">

                                <ul>
                                    <li><span>订单号</span><span>{{item.ticket}}</span></li>
                                    <li></li>
                                    <li><span>手续费</span><span>{{item.commission.toFixed(2)}}</span></li>
                                    <li><span>库存费</span><span>{{item.swap.toFixed(2)}}</span></li>
                                </ul>

                        </div>

                    <div class="open">
                        <div class="open-left">
                            <ul>
                                <div>
                                    <li><span>建仓</span><span>{{item.symbol == 'XAU' || item.symbol == 'GOLD'?item.openPrice.toFixed(2):item.openPrice.toFixed(3)}}</span></li>
                                    <li><span>最新</span><span>{{getNewPrice(index)}}</span></li>
                                </div>
                                <div style="padding-left:20.33px">
                                    <li><span>止损</span><span>{{item.stopLoss !== 0 && (item.symbol == 'XAU' || item.symbol == 'GOLD')?item.stopLoss.toFixed(2):(item.stopLoss !== 0 && (item.symbol == 'XAG' || item.symbol == 'SILVER')?item.stopLoss.toFixed(3):'未设置')}}</span></li>
                                    <li><span>止盈</span><span>{{item.takeProfit !== 0 && (item.symbol == 'XAU' || item.symbol == 'GOLD')?item.takeProfit.toFixed(2):(item.takeProfit !== 0 && (item.symbol == 'XAG' || item.symbol == 'SILVER')?item.takeProfit.toFixed(3):'未设置')}}</span></li>
                                </div>
                            </ul>
                        </div>
                        <div class="open-right">
                            <p :style="{color:getprofit(index)>=0?'#FF6738':'#17CF84'}">{{getprofit(index)}}</p>
                            <p>浮动盈亏</p>
                        </div>
                    </div>
                    <div class="bottom">
                        <p @click="handleset(index)">止损止盈<span>></span></p>
                        <p @click="handleListPc(index)">平仓</p>
                    </div>
                </div>
                <div class="setbox" v-show="selectset == index">
                    <div class="title">止损止盈<span>({{item.ticket}})</span></div>
                    <div class="content">
                        <div class="top"><p><span :style="{backgroundColor:item.orderDirection == 0?'#FF4F36':(item.orderDirection == 1?'#17CF84':'')}">{{item.orderDirection == 0?'买入':(item.orderDirection == 1?'卖出':'')}}</span><span>{{item.symbol == 'XAU' || item.symbol == 'GOLD'?'伦敦金':(item.symbol == 'XAG' || item.symbol == 'SILVER'?'伦敦银':'美元')}}</span><span>{{item.lots}}手</span></p><p :style="{color:getprofit(index)>=0?'red':'#17CF84'}">{{getprofit(index)}}</p></div>
                        <ul>
                            <div class="left">
                                <li>建仓<span>{{item.symbol == 'XAU' || item.symbol == 'GOLD'?item.openPrice.toFixed(2):item.openPrice.toFixed(3)}}</span></li>
                                <li>最新<span>{{getNewPrice(index)}}</span></li>
                            </div>

                            <div class="main">
                                <li>止盈<span>{{item.takeProfit !== 0 && (item.symbol == 'XAU' || item.symbol == 'GOLD')?item.takeProfit.toFixed(2):(item.takeProfit !== 0 && (item.symbol == 'XAG' || item.symbol == 'SILVER')?item.takeProfit.toFixed(3):'未设置')}}</span></li>
                                <li>止损<span>{{item.stopLoss !== 0 && (item.symbol == 'XAU' || item.symbol == 'GOLD')?item.stopLoss.toFixed(2):(item.stopLoss !== 0 && (item.symbol == 'XAG' || item.symbol == 'SILVER')?item.stopLoss.toFixed(3):'未设置')}}</span></li>
                            </div>

                            <div class="right">
                                <li>手续费<span>{{item.commission.toFixed(2)}}</span></li>
                                <li>库存费<span>{{item.swap.toFixed(2)}}</span></li>
                            </div>
                        </ul>
                    </div>
                    <div class="tips">
                        <p>{{"至少远离最新价"+stopsLevel+"点。一直有效，直至客户自行取消"}}</p>
                        <!-- <p v-show="this.$store.state.mnlogin">至少远离最新价200点。一直有效，直至客户自行取消</p> -->
                    </div>
                        <div class="sliderdown-item">
                            <p>止损
                                <span v-show="getisgoldcc">{{zhisun?comtotalzhisun(index):getzhisun(index)}}</span>
                                <span v-show="!getisgoldcc">{{zhisun?slcomtotalzhisun(index):getzhisun(index)}}</span>
                            </p>
                            <p>
                                <img @click="zhisuncut(index)" src="@/assets/cut.png" alt="" class="cut">
                                <input type="num" placeholder="未设置" v-model="zhisun" @input="onzhisun">
                                <img @click="zhisunadd(index)" src="@/assets/add.png" alt="" class="add">
                                <span @click="removezhisun">清空</span>
                            </p>
                        </div>
                        <div class="sliderdown-item">
                            <p>止盈
                                <span v-show="getisgoldcc">{{zhiying?comtotalzhiying(index):getzhiying(index)}}</span>
                                <span v-show="!getisgoldcc">{{zhiying?slcomtotalzhiying(index):getzhiying(index)}}</span>
                            </p>
                            <p>
                                <img @click="zhiyingcut(index)" src="@/assets/cut.png" alt="" class="cut">
                                <input type="num" placeholder="未设置" v-model="zhiying" @input="onzhiying">
                                <img @click="zhiyingadd(index)" src="@/assets/add.png" alt="" class="add">
                                <span @click="removezhiying">清空</span>
                            </p>
                        </div>

                    <div class="reviseBtn">
                        <p @click="handleBack(index)">取消修改</p>
                        <p  v-preventReClick @click="confirmRevise(index)">确认修改</p>
                    </div>
                </div>

                <!-- fixedbox -->
                <div class="pcFixedBox" v-show="select == index">
                    <div class="title">平仓<span>({{item.ticket}})</span><img @click="closefixbox(index)" src="@/assets/close.png" alt=""></div>
                    <div class="content">
                        <div class="top"><p><span :style="{backgroundColor:item.orderDirection == 0?'#FF4F36':(item.orderDirection == 1?'#17CF84':'')}">{{item.orderDirection == 0?'买入':(item.orderDirection == 1?'卖出':'')}}</span><span>{{item.symbol == 'XAU' || item.symbol == 'GOLD'?'伦敦金':(item.symbol == 'XAG' || item.symbol == 'SILVER'?'伦敦银':'美元')}}</span><span>{{item.lots.toFixed(2)}}手</span></p><p :style="{color:getprofit(index)>=0?'red':'#17CF84'}">{{getprofit(index)}}</p></div>
                        <ul>
                            <div class="left">
                                <li>建仓<span>{{item.symbol == 'XAU' || item.symbol == 'GOLD'?item.openPrice.toFixed(2):item.openPrice.toFixed(3)}}</span></li>
                                <li>最新<span>{{getNewPrice(index)}}</span></li>
                            </div>

                            <div class="main">
                                <li>止盈<span>{{item.takeProfit !== 0 && (item.symbol == 'XAU' || item.symbol == 'GOLD')?item.takeProfit.toFixed(2):(item.takeProfit !== 0 && (item.symbol == 'XAG' || item.symbol == 'SILVER')?item.takeProfit.toFixed(3):'未设置')}}</span></li>
                                <li>止损<span>{{item.stopLoss !== 0 && (item.symbol == 'XAU' || item.symbol == 'GOLD')?item.stopLoss.toFixed(2):(item.stopLoss !== 0 && (item.symbol == 'XAG' || item.symbol == 'SILVER')?item.stopLoss.toFixed(3):'未设置')}}</span></li>
                            </div>

                            <div class="right">
                                <li>手续费<span>{{item.commission.toFixed(2)}}</span></li>
                                <li>库存费<span>{{item.swap.toFixed(2)}}</span></li>
                            </div>
                        </ul>
                    </div>
                    <div class="fiexbottom">
                        <p>平仓手数</p>
                        <p>
                            <img @click="cut" src="@/assets/cut.png" alt="">
                            <input type="num" v-model.number="initlot" @input="oninput" @focus="onfocus" @blur="onblur">
                            <img @click="add" src="@/assets/add.png" alt="">
                        </p>
                        <p>
                            <span :class="half?'active':'actived'" @click="handlehalf(index)">1/2</span>
                            <span :class="whole?'active':'actived'" @click="handlewhole(index)">全部</span>
                        </p>
                    </div>
                    <div v-preventReClick class="btn" @click="handleIndexPc(index)">平仓</div>
                </div>

            </div>
        </div>

        <div class="pingcangmask" @click="handlemask" v-show="buyPingShow || sellPingShow || allPingShow || fixboxshow || faqshow"></div>
        <!-- 平仓买单确认框 -->
        <div class="confirmbox" v-show="buyPingShow">
            <div class="title">平仓买单</div>
            <p>成功提交后将平仓该账户所有持仓的买入（做多）订单。</p>
            <ul>
                <li @click="removeConfirmbox()">取消</li>
                <li v-preventReClick @click="handleduo">平仓</li>
            </ul>
        </div>

        <!-- 平仓卖单确认框 -->
        <div class="confirmbox" v-show="sellPingShow">
            <div class="title">平仓卖单</div>
            <p>成功提交后将平仓该账户所有持仓的卖出（做空）订单。</p>
            <ul>
                <li @click="removeConfirmbox()">取消</li>
                <li v-preventReClick @click="handleSellConfirmbox()">平仓</li>
            </ul>
        </div>

        <!-- 一键全平确认框 -->
        <div class="confirmbox" v-show="allPingShow">
            <div class="title">一键全平</div>
            <p>成功提交后将平仓该账户所有持仓订单。</p>
            <ul>
                <li @click="removeConfirmbox()">取消</li>
                <li v-preventReClick @click="handleAll">平仓</li>
            </ul>
        </div>
        </div>
        </mescroll-vue>
 
    </div>

</template>

<script>
import MescrollVue from 'mescroll.js/mescroll.vue'
import Watermark from '@/utils/watermark'
import pako from 'pako'
import {allholdmsg,stopsLevelXAU,accountMsg,BuyPc,SellPc,AllPc,batchPc,revisecc,utf8ByteToUnicodeStr} from '@/utils/socket2.js';
import {mapState,mapMutations,mapAction,mapGetters} from 'vuex'
import Vue from 'vue';
export default {
    components: {
		MescrollVue // 注册mescroll组件
	},
    inject:['reload'], //注入刷新当前页依赖 来自app.vue
    name:"holds",
    data(){
        return{
            mnwatermark:false,//模拟账户水印
            stopsLevel:null,//挂单距离提示
            loadingShow:false,//加载tip
            faqshow:false,//预付款弹窗
            onLine: navigator.onLine, //监听网络状态
            eyeshow:true,
            closeBuy:false,//平仓买单开关
            closeSell:false,//平仓卖单开关
            closeAll:false,//平仓所有单开关
            closeBatch:false,//平仓分批次开关
            half:false, // 2分之一按钮
            whole:false, //全部按钮

            select:-1,
            selectset:-1,
            fixboxshow:false,//底部fixbox显示隐藏
            initlot:0.05,//底部平仓手数

            currentIndex:0,
            
            zhisun:null,//设置止损
            zhiying:null,//设置止盈

            goldflag:true,
            silverflag:true,

            clicktotal:0,
            clicktotals:0,
            silverclicktotal:0,
            silverclicktotals:0,

            // $store.state.confirmrevised:false,//确认修改持仓.

            dingdanshow:false,
            buyPingShow:false,
            sellPingShow:false,
            allPingShow:false,
            arrlist:[],
            accountInfoArr:[],

            mainShow:false,//控制库存费等显示隐藏

            hasmsg:false,

            getisgoldcc:false,//设置止损止盈判断是否黄金

            mescroll: null, // mescroll实例对象
			mescrollDown:{
                auto:false,
                callback:this.downCallback
            }, //下拉刷新的配置. (如果下拉刷新和上拉加载处理的逻辑是一样的,则mescrollDown可不用写了)
			mescrollUp: { // 上拉加载的配置.
                use:false,
                auto:false,
			},

        }
    },
    methods:{

        // 点击预付款faq图标
        handlefaq(){
            this.faqshow = true
        },

        // 点击取消faq弹窗
        removefaq(){
            this.faqshow = false
        },

        // eyes星星
        showeyes(){
            this.eyeshow = !this.eyeshow
        },

        // mescroll组件初始化的回调,可获取到mescroll对象
		mescrollInit (mescroll) {
			this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
		},

        downCallback (mescroll) {

            setTimeout(() => {
                this.reload()                
            }, 2000);
            
	    },
        
        // 点击设置止损止盈
        handleset(index){
            this.selectset = this.selectset == index?-1:index
            this.fixboxshow = true //显示mask
            // 判断是否黄金 专业投资者
            if(this.arrlist[index].symbol == 'XAU'){
               this.getisgoldcc = true 
            }else if(this.arrlist[index].symbol == 'XAG'){
                this.getisgoldcc = false
            }

            // 判断是否黄金 非专业投资者
            if(this.arrlist[index].symbol == 'GOLD'){
               this.getisgoldcc = true 
            }else if(this.arrlist[index].symbol == 'SILVER'){
                this.getisgoldcc = false
            }

            this.removezhisun() //每次点击清空数据
            this.removezhiying() //每次点击清空数据

        },

        handleBack(index){
            this.selectset = -1
            this.fixboxshow = false //关闭mask
        },

        // 确认修改止损止盈
        confirmRevise(index){
            var that = this
            that.global.ws.onmessage = that.onmessageg
            that.$store.state.confirmrevised = true //点击确认开关打开
            if (that.global.ws && that.global.ws.readyState == 1 && that.$store.state.confirmrevised) {

                revisecc(that.arrlist[index].ticket,null,that.zhisun?that.zhisun:null,that.zhiying?that.zhiying:null,null,that.global.ws)
            }
            that.loadingShow = true
        },

        onzhisun(e){
            if(this.getisgoldcc){
                e.target.value = (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
            }else if(!this.getisgoldcc){
                e.target.value = (e.target.value.match(/^\d*(\.?\d{0,3})/g)[0]) || null
            }
            this.zhisun = e.target.value
        },

        onzhiying(e){
            if(this.getisgoldcc){
                e.target.value = (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
            }else if(!this.getisgoldcc){
                e.target.value = (e.target.value.match(/^\d*(\.?\d{0,3})/g)[0]) || null
            }
            this.zhiying = e.target.value
        },

        zhisunadd(index){
   
            // 黄金止损加
            if(this.getisgoldcc){

                var initnum = 0.01

                if(this.clicktotal == 0 && this.goldflag){
                    if( this.arrlist[index].orderDirection == 0){
                        this.zhisun = (this.Sub(this.getNewPrice(index),(this.$store.state.goldstopsLevel/100)))
                    }else if( this.arrlist[index].orderDirection == 1){
                        this.zhisun = (this.NumberAdd(this.getNewPrice(index),(this.$store.state.goldstopsLevel/100)))
                    }

                }
                this.clicktotal++
                this.zhisun = this.NumberAdd(this.zhisun,initnum)

            }
            // 白银止损加            
            if(!this.getisgoldcc){
                var initnum = 0.001
                if(this.silverclicktotal == 0 && this.silverflag){

                        if( this.arrlist[index].orderDirection == 0){
                            this.zhisun = (this.Sub(this.getNewPrice(index),(this.$store.state.silverstopsLevel/1000)))
                        }else if( this.arrlist[index].orderDirection == 1){
                            this.zhisun = (this.NumberAdd(this.getNewPrice(index),(this.$store.state.silverstopsLevel/1000)))
                        }

                }
                this.silverclicktotal++
                this.zhisun = this.NumberAdd(this.zhisun,initnum)

            }
        },

        zhisuncut(index){
            
            // 黄金止损减
            if(this.getisgoldcc){
                var initnum = 0.01
                if(this.clicktotal == 0 && this.goldflag){

                    if( this.arrlist[index].orderDirection == 0){
                        this.zhisun = (this.Sub(this.getNewPrice(index),(this.$store.state.goldstopsLevel/100)))
                    }else if( this.arrlist[index].orderDirection == 1){
                        this.zhisun = (this.Sub(this.getNewPrice(index),(this.$store.state.goldstopsLevel/100)))
                    }

                }
                this.clicktotal++
                if(this.zhisun <= 0)return false
                this.zhisun = this.Sub(this.zhisun,initnum)

            }
            // 白银止损减
            if(!this.getisgoldcc){
                var initnum = 0.001
                if(this.silverclicktotal == 0 && this.silverflag){

                        if( this.arrlist[index].orderDirection == 0){
                            this.zhisun = (this.Sub(this.getNewPrice(index),(this.$store.state.silverstopsLevel/1000)))
                        }else if( this.arrlist[index].orderDirection == 1){
                            this.zhisun = (this.NumberAdd(this.getNewPrice(index),(this.$store.state.silverstopsLevel/1000)))
                        }
                }
                this.silverclicktotal++
                if(this.zhisun <= 0)return false
                this.zhisun = this.Sub(this.zhisun,initnum)

            }

        },

        zhiyingadd(index){
            // 黄金止盈加
            if(this.getisgoldcc){
                var initnum = 0.01
                if(this.clicktotals == 0 && this.goldflag){

                        if( this.arrlist[index].orderDirection == 0){
                            this.zhiying = (this.NumberAdd(this.getNewPrice(index),(this.$store.state.goldstopsLevel/100)))
                        }else if( this.arrlist[index].orderDirection == 1){
                            this.zhiying = (this.Sub(this.getNewPrice(index),(this.$store.state.goldstopsLevel/100)))
                        }

                }
                this.clicktotals++
                this.zhiying = this.NumberAdd(this.zhiying,initnum)
            }
            
            // 白银止盈加
            if(!this.getisgoldcc){
                var initnum = 0.001
                if(this.silverclicktotals == 0 && this.silverflag){

                    if( this.arrlist[index].orderDirection == 0){
                        this.zhiying = (this.NumberAdd(this.getNewPrice(index),(this.$store.state.silverstopsLevel/1000)))
                    }else if( this.arrlist[index].orderDirection == 1){
                        this.zhiying = (this.Sub(this.getNewPrice(index),(this.$store.state.silverstopsLevel/1000)))
                    }

                }
                this.silverclicktotals++
                this.zhiying = this.NumberAdd(this.zhiying,initnum)
            }
        },

        zhiyingcut(index){
            // 黄金止盈减
            if(this.getisgoldcc){
                var initnum = 0.01
                if(this.clicktotals == 0 && this.goldflag){
                        if( this.arrlist[index].orderDirection == 0){
                            this.zhiying = (this.NumberAdd(this.getNewPrice(index),(this.$store.state.goldstopsLevel/100)))
                        }else if( this.arrlist[index].orderDirection == 1){
                            this.zhiying = (this.Sub(this.getNewPrice(index),(this.$store.state.goldstopsLevel/100)))
                        }

                }
                this.clicktotals++
                if(this.zhiying <= 0)return false
                this.zhiying = this.Sub(this.zhiying,initnum)
            }
            // 白银止盈减
            if(!this.getisgoldcc){
                var initnum = 0.001
                if(this.silverclicktotals == 0 && this.silverflag){

                        if( this.arrlist[index].orderDirection == 0){
                            this.zhiying = (this.NumberAdd(this.getNewPrice(index),(this.$store.state.silverstopsLevel/1000)))
                        }else if( this.arrlist[index].orderDirection == 1){
                            this.zhiying = (this.Sub(this.getNewPrice(index),(this.$store.state.silverstopsLevel/1000)))
                        }

                }
                this.silverclicktotals++
                if(this.zhiying <= 0)return false
                this.zhiying = this.Sub(this.zhiying,initnum)
            }
        },

        removezhisun(){
            if(this.getisgoldcc){
                this.zhisun = null
                this.clicktotal = 0
            }else if(!this.getisgoldcc){
                this.zhisun = null
                this.silverclicktotal = 0
            }
        },

        removezhiying(){
            if(this.getisgoldcc){
                this.zhiying = null
                this.clicktotals = 0
            }else if(!this.getisgoldcc){
                this.zhiying = null
                this.silverclicktotals = 0
            }
        },

        // 点击平仓按钮
        handleListPc(index){
            this.select = this.select == index?-1:index

            this.fixboxshow = true //显示mask
            this.initlot = (this.arrlist[index].lots).toFixed(2) //每次点击都清空手数为全部
        },

        // 关闭底部fixbox
        closefixbox(index){
            this.select = -1
            this.fixboxshow = false //关闭mask
            this.half = false //关闭二分之一高亮
            this.whole = false //关闭全部高亮
        },

        // 点击蒙层关闭
        handlemask(){
            this.buyPingShow = false
            this.sellPingShow = false
            this.allPingShow = false
            this.faqshow = false
            this.fixboxshow = false //mask关闭
            this.select = -1
            this.selectset = -1
            this.half = false //关闭二分之一高亮
            this.whole = false //关闭全部高亮
        },

        // 计算最新价
        getNewPrice(index){

            if((this.$store.state.goldSell || this.$store.state.silverSell) > 0){
                // 如果是黄金 专业投资者
                if(this.arrlist[index].symbol == 'XAU' && this.arrlist[index].orderDirection == 0){
                return this.getGoldSell.toFixed(2)
                }else if(this.arrlist[index].symbol == 'XAU' && this.arrlist[index].orderDirection == 1){
                    return this.getGoldBuy.toFixed(2)
                }

                // 如果是黄金 非专业投资者
                if(this.arrlist[index].symbol == 'GOLD' && this.arrlist[index].orderDirection == 0){
                return this.getGoldSell.toFixed(2)
                }else if(this.arrlist[index].symbol == 'GOLD' && this.arrlist[index].orderDirection == 1){
                    return this.getGoldBuy.toFixed(2)
                }

                // 如果是白银 专业投资者
                if(this.arrlist[index].symbol == 'XAG'  && this.arrlist[index].orderDirection == 0){
                    return this.getSilverSell.toFixed(3)
                }else if(this.arrlist[index].symbol == 'XAG' && this.arrlist[index].orderDirection == 1){
                    return this.getSilverBuy.toFixed(3)
                }

                // 如果是白银 非专业投资者
                if(this.arrlist[index].symbol == 'SILVER'  && this.arrlist[index].orderDirection == 0){
                    return this.getSilverSell.toFixed(3)
                }else if(this.arrlist[index].symbol == 'SILVER' && this.arrlist[index].orderDirection == 1){
                    return this.getSilverBuy.toFixed(3)
                }
            }else{
                return '--.--'
            }

        },

        // 计算列表浮动盈亏
        getprofit(index){


            if((this.$store.state.goldSell || this.$store.state.silverSell) > 0){
                // 如果是黄金 专业投资者
                if(this.arrlist[index].symbol == 'XAU'  && this.arrlist[index].orderDirection == 0){
                    return (((this.getNewPrice(index) - this.arrlist[index].openPrice)*this.arrlist[index].lots)*100).toFixed(2)
                }else if(this.arrlist[index].symbol == 'XAU'  && this.arrlist[index].orderDirection == 1){
                    return (((this.arrlist[index].openPrice - this.getNewPrice(index))*this.arrlist[index].lots)*100).toFixed(2)
                }

                // 如果是黄金 非专业投资者
                if(this.arrlist[index].symbol == 'GOLD'  && this.arrlist[index].orderDirection == 0){
                    return (((this.getNewPrice(index) - this.arrlist[index].openPrice)*this.arrlist[index].lots)*100).toFixed(2)
                }else if(this.arrlist[index].symbol == 'GOLD'  && this.arrlist[index].orderDirection == 1){
                    return (((this.arrlist[index].openPrice - this.getNewPrice(index))*this.arrlist[index].lots)*100).toFixed(2)
                }

                // 如果是白银 专业投资者
                if(this.arrlist[index].symbol == 'XAG'  && this.arrlist[index].orderDirection == 0){
                    return (((this.getNewPrice(index) - this.arrlist[index].openPrice)*this.arrlist[index].lots)*5000).toFixed(2)
                }else if(this.arrlist[index].symbol == 'XAG'  && this.arrlist[index].orderDirection == 1){
                    return (((this.arrlist[index].openPrice - this.getNewPrice(index))*this.arrlist[index].lots)*5000).toFixed(2)
                }

                // 如果是白银 非专业投资者
                if(this.arrlist[index].symbol == 'SILVER'  && this.arrlist[index].orderDirection == 0){
                    return (((this.getNewPrice(index) - this.arrlist[index].openPrice)*this.arrlist[index].lots)*5000).toFixed(2)
                }else if(this.arrlist[index].symbol == 'SILVER'  && this.arrlist[index].orderDirection == 1){
                    return (((this.arrlist[index].openPrice - this.getNewPrice(index))*this.arrlist[index].lots)*5000).toFixed(2)
                }
            }else{
                return '--.--'
            }
        },

        // 买单：（最买新价-建仓价格）* 手数
        // 卖单：（建仓价格-最新卖价）* 手数

        // 开启websocket
        initWebpack(){

            var that = this

            that.closefixbox()

            if (that.global.ws && that.global.ws.readyState == 1) {


                allholdmsg(that.global.ws)
                accountMsg(that.global.ws)

                stopsLevelXAU(that.global.ws,that.$store.state.dealgold) //获取专业投资者与非专业投资者挂单距离
                
            }

            that.global.ws.onmessage = that.onmessageg

        },

        onmessageg(evt){

            var data = atob(evt.data);
            var data2 = pako.inflateRaw(data);
            var arr = new Uint16Array(data2);
            var strData   = utf8ByteToUnicodeStr(arr);
            var obj = JSON.parse(strData)

            
            // 账户信息
            if(obj.act == 'get_money_info'){
                this.accountInfoArr = []
                this.accountInfoArr.push(obj.data)
            }

            // 获取挂单距离 因为懒 所以也获取这个挂单距离
            if(obj.act == 'get_stop_level'){

                if(obj.success == true){
                    this.stopsLevel = obj.data.stopsLevel
                }
            }

            // 所有持仓单操作
            if(obj.act == 'get_open_orders'){

                if(obj.arr){

                    obj.arr.sort(function(a, b) {
                        let aTimeString = a['openTime']
                        let bTimeString = b['openTime']
                        let aTime = new Date(aTimeString).getTime()
                        let bTime = new Date(bTimeString).getTime()
                        return aTime - bTime
                    });
                    
                    this.arrlist = []
                    this.arrlist = obj.arr

                    this.hasmsg = true //没有任何持仓单盒子关闭

                }else if(!obj.arr){
                    this.arrlist = []
                    this.hasmsg = false //没有任何持仓单盒子打开
                }
                this.$emit('chicanglength',this.arrlist.length)

            }

            // 平仓买单信息处理
            if(this.closeBuy && obj.act == 'close_all_buy_open_order'){
                if(obj.success){
                    this.buyPingShow = false //平仓买单弹窗关闭
                    this.closeBuy = false //平仓买单开关关闭
                    this.$toast("平常成功")
                    this.loadingShow = false
                }else{
                    this.buyPingShow = false //平仓买单弹窗关闭
                    this.closeBuy = false //平仓买单开关关闭
                    this.loadingShow = false
                    this.$toast(obj.msg)
                }
            }

            // 平仓卖单信息处理
            if(this.closeSell && obj.act == 'close_all_sell_open_order'){
                if(obj.success){
                    this.sellPingShow = false //平仓卖单弹窗关闭
                    this.closeSell = false //平仓买单开关关闭
                    this.$toast("平仓成功")
                    this.loadingShow = false
                }else{
                    this.sellPingShow = false //平仓卖单弹窗关闭
                    this.closeSell = false //平仓买单开关关闭
                    this.loadingShow = false
                    this.$toast(obj.msg)
                }
            }

            // 平仓所有单信息处理
            if(this.closeAll){

                if(obj.success){
                    this.allPingShow = false //平仓所有单弹窗关闭
                    this.closeAll = false //平仓所有但开关关闭
                    this.$toast("平仓成功")
                    this.loadingShow = false
                }else{
                    this.allPingShow = false //平仓所有单弹窗关闭
                    this.closeAll = false //平仓所有但开关关闭
                    this.loadingShow = false
                    this.$toast(obj.msg)
                }
            }

            // 平仓分批次信息处理
            if(obj.act == 'close_open_order' && this.closeBatch){

                if(obj.success){
                    this.select = -1
                    this.fixboxshow = false //mask关闭
                    this.closeBatch = false //平仓分批次单开关关闭
                    this.$toast("平仓成功")
                    this.loadingShow = false
                }else{
                    // this.fixboxshow = false //mask关闭
                    this.closeBatch = false //平仓分批次单开关关闭
                    this.$toast(obj.msg)
                    this.loadingShow = false
                    // this.select = -1
                }
            }

            // 修改持仓信息处理
            if(obj.act == 'order_modify' && this.$store.state.confirmrevised){

                if(obj.success){
                    this.selectset = -1 //关闭底框
                    this.fixboxshow = false //mask关闭
                    this.$store.state.confirmrevised = false //修改持仓开关关闭
                    this.$toast('修改成功')
                    this.loadingShow = false
                    this.initWebpack()
                }else{
                    // this.fixboxshow = false //mask关闭
                    this.$store.state.confirmrevised = false //修改持仓开关关闭
                    this.$toast(obj.msg)
                    this.loadingShow = false

                    // this.selectset = -1
                }
            }

            // 全局订单推送
            if(obj.act == 'order_update'){

                allholdmsg(this.global.ws)
                accountMsg(this.global.ws)

                stopsLevelXAU(this.global.ws,this.$store.state.dealgold) //获取专业投资者与非专业投资者挂单距离

                if(this.$store.state.login){



                    this.$store.state.ordertipshow = true
                    
                    this.$store.state.ordertype = obj.msg.replace(/[0-9]/g,"")

                    this.$store.state.orderticket = obj.msg.replace(/[^\d.]/g,"");
                    this.$store.state.ordersymbol = obj.data.symbol
                    this.$store.state.orderdeal = obj.data.orderDirection
                    this.$store.state.orderopenprice = obj.data.openPrice
                    this.$store.state.ordercloseprice = obj.data.closePrice
                    this.$store.state.orderlots = obj.data.lots
                    this.$store.state.orderopentime = obj.data.openTime
                    this.$store.state.orderclosetime = obj.data.closeTime

                    setTimeout(() => {

                        this.$store.state.ordertipshow = false

                    }, 5000)
                }

                // setTimeout(() => {

                //     this.reload()

                // }, 1500)
            }
    
        },

        handleicon(index){

            let _el = this.$refs.mainShow[index]		//	通过下标找到对应同级节点
            if (_el.getAttribute('class') === 'numbox') {
                _el.setAttribute('class', 'mainactive')
            } else {
                _el.setAttribute('class', 'numbox')
            }


            let _elm = this.$refs.mainShows[index]
             if (_elm.getAttribute('class') === 'collectActive') {
                _elm.setAttribute('class', 'collectActived')
            } else {
                _elm.setAttribute('class', 'collectActive')
            }

        },

        //处理买单、卖单、一键全平点击事件

        handlePc(event){
            this[event] = true
        },
        
        removeConfirmbox(){
            this.buyPingShow = false
            this.sellPingShow = false
            this.allPingShow = false
        },

        //处理买单、卖单、一键全平点击事件


        // 平仓买单
        handleduo(){
            var that = this
            that.global.ws.onmessage = that.onmessageg
            that.closeBuy = true //平仓买单开关打开

            if (that.global.ws && that.global.ws.readyState == 1 && that.closeBuy) {
                BuyPc(that.global.ws)
            }

            that.loadingShow = true
        },

        // 平仓卖单
        handleSellConfirmbox(){
            var that = this
            that.global.ws.onmessage = that.onmessageg
            that.closeSell = true //平仓卖单开关打开
            if (that.global.ws && that.global.ws.readyState == 1 && that.closeSell) {
                SellPc(that.global.ws)
            }
            that.loadingShow = true
        },

        //平仓所有单
        handleAll(){
            var that = this
            that.global.ws.onmessage = that.onmessageg
            that.closeAll = true //所有单平仓开关打开
            if (that.global.ws && that.global.ws.readyState == 1 && that.closeAll) {
                AllPc(that.global.ws)
            }

            that.loadingShow = true
        },

        handlehalf(index){
            this.initlot = ((this.arrlist[index].lots) / 2).toFixed(2)
            this.half = true
            this.whole = false

        },
        
        handlewhole(index){
            this.initlot = (this.arrlist[index].lots).toFixed(2)
            this.whole = true
            this.half = false
  
        },

        // 点击底部fixbox按钮平仓
        handleIndexPc(index){
            var that = this
            that.global.ws.onmessage = that.onmessageg
            that.closeBatch = true //平仓分批次开关打开
            if (that.global.ws && that.global.ws.readyState == 1 && that.closeBatch) {
 
                batchPc(that.arrlist[index].ticket,that.initlot,that.global.ws)
            }

            that.loadingShow = true

        },


        NumberAdd(arg1, arg2){
            var r1,r2,m,n
            try{
                r1 = arg1.toString().split('.')[1].length
            } catch (e){
                r1 = 0
            }
            try{
                r2 = arg2.toString().split('.')[1].length
            } catch (e){
                r2 = 0
            }
            m = Math.pow(10, Math.max(r1, r2))
            n = ( r1 >= r2 ) ? r1 : r2
            return ((arg1 * m + arg2 * m ) / m ).toFixed(n)
        },

        Sub(arg1, arg2) {
            arg1 = parseFloat(arg1);
            arg2 = parseFloat(arg2);
            var r1, r2, m, n;
            try {
                r1 = arg1.toString().split(".")[1].length
            } catch (e) {
                r1 = 0
            }
            try {
                r2 = arg2.toString().split(".")[1].length
            } catch (e) {
                r2 = 0
            }
            m = Math.pow(10, Math.max(r1, r2));
            //动态控制精度长度
            n = (r1 >= r2) ? r1 : r2;
            return ((arg1 * m - arg2 * m ) / m ).toFixed(n)
        },

        // 监听平仓交易手数输入框
        oninput(e) {
            e.target.value = (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
            this.initlot = e.target.value
        },

        onfocus(e){
            e.target.value=''
            this.initlot = e.target.value
        },

        onblur(e){
            e.target.value = this.initlot
        },
        // 监听市价交易手数输入框

        // 加
        add(){
            var lots = 0.05 
            this.initlot = Number(this.NumberAdd(this.initlot,lots))
        },

        // 减
        cut(){
            if(this.initlot <= 0.05){
                this.initlot = 0.05 
                return false
            }
            var lots = 0.05 
            this.initlot = Number(this.Sub(this.initlot,lots))
            if(Number(this.Sub(this.initlot,lots)) <= 0.05){
                this.initlot = 0.05
            }
        },

        // 计算黄金止损预计 
        comtotalzhisun(index){
            if( this.arrlist[index].orderDirection == 0){
                return '预计 ' + (((this.zhisun - this.arrlist[index].openPrice)*this.arrlist[index].lots)*100).toFixed(2)
            }else if( this.arrlist[index].orderDirection == 1){
                return '预计 ' + (((this.arrlist[index].openPrice - this.zhisun)*this.arrlist[index].lots)*100).toFixed(2)
            }
        },

        // 计算黄金止盈预计 
        comtotalzhiying(index){
            if( this.arrlist[index].orderDirection == 0){
                return '预计 ' + (((this.zhiying - this.arrlist[index].openPrice)*this.arrlist[index].lots)*100).toFixed(2)
            }else if( this.arrlist[index].orderDirection == 1){
                return '预计 ' + (((this.arrlist[index].openPrice - this.zhiying)*this.arrlist[index].lots)*100).toFixed(2)
            }
        },

        // 计算白银止损预计 
        slcomtotalzhisun(index){
            if( this.arrlist[index].orderDirection == 0){
                return '预计 ' + (((this.zhisun - this.arrlist[index].openPrice)*this.arrlist[index].lots)*5000).toFixed(2)
            }else if( this.arrlist[index].orderDirection == 1){
                return '预计 ' + (((this.arrlist[index].openPrice - this.zhisun)*this.arrlist[index].lots)*5000).toFixed(2)
            }
        },

        // 计算白银止盈预计 
        slcomtotalzhiying(index){
            if( this.arrlist[index].orderDirection == 0){
                return '预计 ' + (((this.zhiying - this.arrlist[index].openPrice)*this.arrlist[index].lots)*5000).toFixed(2)
            }else if( this.arrlist[index].orderDirection == 1){
                return '预计 ' + (((this.arrlist[index].openPrice - this.zhiying)*this.arrlist[index].lots)*5000).toFixed(2)
            }
        },

        // 计算止损
        getzhisun(index){
            if(this.getisgoldcc){

                if( this.arrlist[index].orderDirection  == 0){ //买入
                    return "<" + (this.getNewPrice(index)-(this.$store.state.goldstopsLevel/100)).toFixed(2)
                }else if( this.arrlist[index].orderDirection  == 1){ //卖出
                    return ">" + this.NumberAdd(this.getNewPrice(index),(this.$store.state.goldstopsLevel/100) )
                }

            }else if(!this.getisgoldcc){
                if( this.arrlist[index].orderDirection  == 0){
                    return "<" + (this.getNewPrice(index)-(this.$store.state.silverstopsLevel/1000)).toFixed(3)
                }else if( this.arrlist[index].orderDirection  == 1){
                    return ">" + this.NumberAdd(this.getNewPrice(index),(this.$store.state.silverstopsLevel/1000))
                }
            }
        },
        

        // 计算止盈
        getzhiying(index){
            if(this.getisgoldcc){
                if( this.arrlist[index].orderDirection == 0){ //买入
                    return ">" + this.NumberAdd(this.getNewPrice(index),(this.$store.state.goldstopsLevel/100) )
                }else if( this.arrlist[index].orderDirection == 1){ //卖出
                    return "<" + (this.getNewPrice(index)-(this.$store.state.goldstopsLevel/100) ).toFixed(2)
                }
            }else if(!this.getisgoldcc){
                if( this.arrlist[index].orderDirection == 0){
                    return ">" + this.NumberAdd(this.getNewPrice(index),(this.$store.state.silverstopsLevel/1000) )
                }else if( this.arrlist[index].orderDirection == 1){
                    return "<" + (this.getNewPrice(index)-(this.$store.state.silverstopsLevel/1000) ).toFixed(3)
                }
            }
        },

        // 监听网络状态
        updateOnlineStatus(e) {
            const { type } = e;
            if(this.onLine = type === 'online'){
                this.$store.state.tips = false
                // this.reload() //重新连接网络之后刷新
            }else{
                this.$store.state.tips = true
            }
        },
        // 销毁时解除事件监听
        beforeDestroy(){
            window.removeEventListener('online',  this.updateOnlineStatus);
            window.removeEventListener('offline', this.updateOnlineStatus);
        },

    },

    computed:{

        // 获取黄金买入行情价
        getGoldBuy(){
            return this.$store.state.goldBuy
        },

        // 获取黄金卖出行情价
        getGoldSell(){
            return this.$store.state.goldSell
        },

        // 获取白银买入价
        getSilverBuy(){
            return this.$store.state.silverBuy
        },
        
        // 获取白银卖出价
        getSilverSell(){
            return this.$store.state.silverSell
        },

        // 获取净值
        getjz(){
            if(Number(this.accountInfoArr[0].AccountBalance)){
                if((this.$store.state.goldSell || this.$store.state.silverSell) > 0){
                    return (this.accountInfoArr[0].AccountBalance + Number(this.getchicang)).toFixed(2)
                }else{
                    return this.accountInfoArr[0].AccountBalance.toFixed(2)
                }
            }
        },

        // 获取持仓盈亏
        getchicang(){
            var tc = 0 //手续费
            var ts = 0 //库存费
            var tt = 0 //最终值
            this.arrlist.forEach(element => {
                tc += element.commission
                ts += element.swap
            });
            tt = (this.getTotalprofit+tc+ts).toFixed(2)
            if((this.$store.state.goldSell || this.$store.state.silverSell) > 0){
                return tt
            }else{
                return '--.--'
            }
        },

        // 获取可用预付款
        getyfk(){
            if(Number(this.accountInfoArr[0].AccountBalance)){
                this.$store.state.payment = (this.getjz - this.accountInfoArr[0].AccountMargin).toFixed(2)
                return (this.getjz - this.accountInfoArr[0].AccountMargin).toFixed(2)
            }    
        },

        // 获取预付款比例
        getbili(){
            if(Number(this.accountInfoArr[0].AccountBalance)){
                return ((this.getjz / this.accountInfoArr[0].AccountMargin)*100).toFixed(2)
            }
        },

        // 计算买入多少手
        getBuyLots(){
            var b = 0
            this.arrlist.forEach(element => {
                if(element.orderDirection == 0){
                    b+=element.lots
                }
            });
            return b.toFixed(2)
        },

        // 计算卖出多少手
        getSellLots(){
            var s = 0
            this.arrlist.forEach(element => {
                if(element.orderDirection == 1){
                    s+=element.lots
                }
            });
            return s.toFixed(2)
        },

        // 合计多少手
        getTotalLots(){
            var t = 0
            this.arrlist.forEach(element => {
                t+=element.lots
            });
            return t.toFixed(2)
        },

        //计算买入盈亏
        getbuyprofit(){
            var gs = this.$store.state.goldSell
            var ss = this.$store.state.silverSell

            var g = 0
            let goldArr = []

            var s = 0 
            let silverArr = []

            var t = 0

            this.arrlist.forEach((element,index) => {

                if(element.orderDirection == 0 && (element.symbol == 'XAU' || element.symbol == 'GOLD')){

                    // 黄金买入价盈亏浮动

                    goldArr.push((((gs - element.openPrice)*element.lots)*100).toFixed(2))

                    // 买单：（最买新价-建仓价格）* 手数
                    // 卖单：（建仓价格-最新卖价）* 手数

                }

                if(element.orderDirection == 0 && (element.symbol == 'XAG' || element.symbol == 'SILVER')){
                    
                    // 白银买入价盈亏浮动 

                    silverArr.push(((((ss - element.openPrice)*element.lots)*5000)).toFixed(2))

                }

            });

            goldArr.map(Number).forEach(item =>{
                g += item
            })

            silverArr.map(Number).forEach(item =>{
                s += item
            })

            t = g + s

            if((this.$store.state.goldSell || this.$store.state.silverSell) > 0){
                return t.toFixed(2)
            }else{
                return '--.--'
            }

        },

        //计算卖出盈亏
        getsellprofit(){

            var gs = this.$store.state.goldBuy
            var ss = this.$store.state.silverBuy

            var g = 0
            let goldArr = []

            var s = 0 
            let silverArr = []

            var t = 0

            this.arrlist.forEach((element,index) => {

                if(element.orderDirection == 1 && (element.symbol == 'XAU' || element.symbol == 'GOLD')){
                    // 黄金买入价盈亏浮动
                    goldArr.push((((element.openPrice - gs)*element.lots)*100).toFixed(2))
                }

                if(element.orderDirection == 1 && (element.symbol == 'XAG' || element.symbol == 'SILVER')){
                    // 白银买入价盈亏浮动 
                    silverArr.push(((((element.openPrice - ss)*element.lots)*5000)).toFixed(2))
                }

            });

            goldArr.map(Number).forEach(item =>{
                g += item
            })

            silverArr.map(Number).forEach(item =>{
                s += item
            })
            
            t = g + s

            if((this.$store.state.goldSell || this.$store.state.silverSell) > 0){
                return t.toFixed(2)
            }else{
                return '--.--'
            }

        },
        
        // 计算总共盈亏
        getTotalprofit(){
            var t = 0
            t = Number(this.getbuyprofit) + Number(this.getsellprofit)
            return t
        },

    },

    careated(){

    },
    watch: {
        $route(to, from) {
            if(to.fullPath == "/hold" &&  from.fullPath == "/deal"){
                //重新获取数据
                this.initWebpack()
            }
        }
    },
    mounted(){
        this.initWebpack()

        // // 加水印
        if(this.$store.state.mnlogin){
            this.mnwatermark = true
        }else{
            this.mnwatermark = false
        }

        // 禁止浏览器自带返回
        history.pushState(null, null, document.URL);
        window.addEventListener('popstate', function () {
            history.pushState(null, null, document.URL);
        });

        // this.$store.state.goldindex = true //必须，返回到交易页面由于是黄金页面所以必须重置为true，避免input黄金白银资金错乱



		window.addEventListener('online',  this.updateOnlineStatus);// 网络由异常到正常时触发
 
		window.addEventListener('offline', this.updateOnlineStatus);// 网络由正常常到异常时触发
    }
}
</script>

<style scoped>
    body{touch-action: none;}
    li{list-style: none;}
    .pingcangmask{background: #000000;width: 100%;height: 100%;opacity: 0.5;position: fixed;left: 0;top: 0;z-index: 887;}

    /* 断网提示 */
    .tips{padding: 9.33px 12px 10px 12px;display: flex;align-items: center;justify-content: space-between;align-items: center;border-radius: 6px;background-color: #FFF5F3;color: #FF4F36;}
    .tips span:nth-of-type(1){padding-left: 11.67px;}
    .tips span:nth-of-type(2){padding-right: 11.33px;}
    
    /* 水印 */
    .water-mark{color:rgba(200, 200, 200, 0.80);font-size: 30px;position: absolute;bottom: 40px;right: 75px;}

    /* .all{padding: 0 12px;margin-top: 15px;} */
    .card{border-radius: 12px;margin: 0 auto;background-image: linear-gradient(to right, #1EBA74, #17CF84);}
    .cardactived{border-top-left-radius: 12px;border-top-right-radius: 12px; margin: 0 auto;background-image: linear-gradient(to right, #FF6738, #FF4F36)}
    .cardactived0{border-top-left-radius: 12px;border-top-right-radius: 12px; margin: 0 auto;background-image: linear-gradient(to right, #BBBBBB, #999999)}
    .card .title{padding: 16px 12.67px 12px 12px;color: #FFFFFF;font-size: 12px;opacity: 0.6;display: flex;justify-content: space-between;align-items: center;}
    .card .title span:nth-of-type(1){display: flex;align-items: center;}
    .openeyes{width: 20px;height: 20px;display: block;}
    .closeeyes{width: 20px;height:20ox;display: block;}
    .card .data{padding: 0 13.33px 18.67px 13.67px;color: #FFFFFF;font-size: 24px;display: flex;justify-content: space-between;align-items: center;line-height: 17px;font-weight: bold;}
    .card ul{padding: 0 12px 18.67px 15px;display: flex;justify-content: space-between;align-items: center;}
    .card ul li{display: flex;align-items: center;justify-content: space-between;}
    .card ul li span{color: #FFFFFF;opacity: 0.8; font-size: 12px;font-weight: bold;line-height: 25px;display: flex;align-items: center;}
    .card ul li .right{padding-left: 26.77px;}
    .card ul li .right span{text-align: right;flex: 1;}
    .card ul li span:nth-of-type(2){opacity: 1;}
    .card-nav{display: flex;height: 80px;display: flex;justify-content: center;align-items: center;background-color: #FFFFFF;border-bottom-left-radius: 12px;border-bottom-right-radius: 12px;display: none;}
    .card-nav div{display: flex;flex-direction: column;flex: 1;color: #999999;font-size: 14px;text-align: center;}
    .card-nav img{width: 24px;height: 24px;display: block;margin: 0 auto;margin-bottom: 8.67px;}

    .deal{background-color: #FFFFFF;border-radius: 12px;margin-top: 10px;}
    .deal ul{padding: 16px 18.33px 12px 18.67px;display: flex;justify-content: space-between;align-items: center;}
    .deal ul li{display: flex;flex-direction: column;text-align: center;}
    .deal ul li p:nth-of-type(1){color: #999999;font-size: 12px;}
    .deal ul li p:nth-of-type(1) span{color: #333333;}
    .deal ul li p:nth-of-type(2){color: #999999;font-size: 16px;font-weight: bold;padding: 18.67px 0 13.33px 0;}
    .deal ul li:nth-of-type(2) p:nth-of-type(2){color: #17CF84;}
    .deal ul li:nth-of-type(3) p:nth-of-type(2){color: #17CF84;}
    .deal ul li button{width: 80px;height: 26px;border-radius: 13px;font-size: 12px;display: flex;justify-content: center;align-items: center;border: none;}
    .deal ul li .firbtn{color: #BBBBBB;background-color: #F5F5F5;}
    .deal ul li .secbtn{color: #17CF84;background-color: #E7FAF2;}
    .deal ul li .thirdbtn{color: #FF4F36;background-color: #FFEDEA;}

    .list-box{padding-bottom: 20px;}
    .list{background-color: #FFFFFF;border-radius: 12px;margin-top: 10px;}
    .list-item{padding: 12px 12px;position: relative;}
    .title{display: flex;justify-content: space-between;align-items: center;}
    .title-left{display: flex;justify-content: flex-start;align-items: center;}
    .title-left p:nth-of-type(1){width: 36px;height: 18px;display: flex;justify-content: center;align-items: center;color: #FFFFFF;font-size: 12px;background-color: #17CF84;margin-right: 6px;border-radius: 9px;}
    .title-left p:nth-of-type(2){margin-right: 9.33px;font-size: 16px;font-weight: bold;color: #333333;}
    .title-left p:nth-of-type(3){font-size: 16px;font-weight: bold;color: #333333;}

    @media screen and (min-width:320px) and (max-width:359px){
        .title-left p:nth-of-type(2),.title-left p:nth-of-type(3){font-size: 12px;}
        .water-mark{bottom:10px;right: 95px;font-size: 25px;}
        .card ul li .right{padding-left: 5px;}
    }

    @media screen and (min-width:360px) and (max-width:374px){
        .card ul li .right{padding-left: 15.77px;}
    }


    .title-time{color: #BBBBBB;font-size: 12px;display: flex;align-items: center;}
    .title-time span:nth-of-type(1){padding-right: 3px;}
    .title-time img{width: 24px;height: 24px;}
    .num{transition: all 0.5s;display: none;}

    .open{display: flex;justify-content: space-between;align-items: center;padding-bottom: 13.33px;}
    .open-left{width: 72%;}
    .open ul{display: flex;justify-content: flex-start;align-items: center;flex-wrap: wrap;margin-top: 8px;}
    .open ul li{font-size: 14px;color: #BBBBBB;display: flex;justify-content: flex-start;align-items: center;margin-top: 5px;}
    /* .open ul li:nth-of-type(2),.open ul li:nth-of-type(4){padding-left: 20.33px;} */
    .open ul li span:nth-of-type(2){padding-left: 8.67px;color: #999999;}
    .open-right p:nth-of-type(1){color: #17CF84;font-weight: bold;font-size: 20px;margin-top: -2px;text-align: right;}
    .open-right p:nth-of-type(2){color: #BBBBBB;font-size: 12px;text-align: right;}
    .list .bottom{display: flex;justify-content: space-between;align-items: center;}
    .list .bottom p:nth-of-type(1){color: #333333;font-size: 14px;}
    .list .bottom p:nth-of-type(1) span{margin-left: 6px;}
    .list .bottom p:nth-of-type(2){width: 62px;height: 26px;background-image: linear-gradient(to right, #FF6738, #FF4F36);display: flex;justify-content: center;align-items: center;border-radius: 13px;color: #FFFFFF;font-size: 14px;}

    .collectActive{transform: rotate(180deg);transition: all 0.5s;}
    .collectActived{transform: rotate(0deg);transition: all 0.5s;}

     /* 平仓买单 */
     .confirmbox{border-top-left-radius: 12px;border-top-right-radius: 12px;background-color: #FFFFFF;position: fixed;bottom: 0;left: 0;right: 0;margin: 0 auto;z-index: 888;}
     .confirmbox .title{text-align: center;padding: 17.67px 0 20.33px 0;color: #333333;font-size: 16px;display: flex;justify-content: center;font-weight: bold;}
     .confirmbox p{padding: 0 33.33px 36.33px 20.67px;color: #333333;font-size: 14px;text-align: left;}
     .confirmbox ul{height: 44px;padding: 0 20px 49px 20px;display: flex;justify-content: space-between;align-items: center;}
     .confirmbox ul li{border-radius: 22px;display: flex;justify-content: center;align-items: center;font-weight: bold;font-size: 16px;}
     .confirmbox ul li:nth-of-type(1){width: 49%;height: 100%;background-color: #EEEEEE;color: #333333;}
     .confirmbox ul li:nth-of-type(2){width: 49%;height: 100%;background-image: linear-gradient(to right, #FF4F36, #FF6738);color: #FFFFFF;}

    /* setbox */
    .setbox{border-top-left-radius: 12px;border-top-right-radius: 12px;background-color: #FFFFFF;position: fixed;bottom: 0;left: 0;right: 0;margin: 0 auto;z-index: 888;}
    .setbox .title{text-align: center;padding: 17.67px 0 20.33px 0;color: #333333;font-size: 16px;display: flex;justify-content: center;font-weight: bold;}
    .setbox .content{padding: 13.33px 0 14.33px 0;background-color: #F8F8F8;margin: 0 12px auto;}
    .setbox .content .top{padding: 0 12px 13.33px 12px;display: flex;justify-content: space-between;align-items: center;}
    .setbox .content .top p:nth-of-type(1){display: flex;justify-content: flex-start;align-items: center;}
    .setbox .content .top p:nth-of-type(1) span:nth-of-type(1){width: 36px;height: 18px;display: flex;justify-content: center;align-items: center;color: #FFFFFF;font-size: 12px;background-color: #17CF84;margin-right: 6px;border-radius: 9px;}
    .setbox .content .top p:nth-of-type(1) span:nth-of-type(2){margin-right: 9.33px;font-size: 16px;font-weight: bold;color: #333333;}
    .setbox .content .top p:nth-of-type(1) span:nth-of-type(3){font-size: 16px;font-weight: bold;color: #333333;}
    .setbox .content .top p:nth-of-type(2){font-size: 16px;color: #FF6738;font-weight: bold;}
    .setbox .content ul{display: flex;justify-content: flex-start;align-items: center;margin: 0 12px auto;}
    .setbox .content ul .left{width: 30%;}
    .setbox .content ul .main{width: 30%;}
    .setbox .content ul .right{width: 30%;}
    .setbox .content ul li{width: 100%; display: flex;align-items: center;font-size: 10px;margin-top: 10px;}
    .setbox .content ul li:nth-of-type(1),.num ul li:nth-of-type(2){margin: 0;}
    .setbox .content ul li span{color: #999999;font-size: 10px;padding-left: 10px;}
    .setbox .content ul li span:nth-of-type(2){padding-left: 9.67px;color: #333333;}
    .setbox .tips{margin: 0 12px auto;color: #999999;font-size: 12px;background-color: #FFFFFF;}

    .cut{width: 22px;height: 22px;display: block;margin-right: 10px;}
    .add{width: 22px;height: 22px;display: block;margin-left: 10px;}
    input{text-align: center;width: 34%;outline: none;border: none;}

    .sliderdown-item{height: 44px;padding: 0 15px;display: flex;justify-content: space-between;align-items: center;border-bottom: 1px solid #EEEEEE;}
    .sliderdown-item p:nth-of-type(1){color: #333333;font-size: 14px;display: flex;align-items: center;justify-content: flex-start;flex: 1;}
    .sliderdown-item p:nth-of-type(1) span{color: #999999;font-size: 12px;padding-left: 8.33px;}
    .sliderdown-item p:nth-of-type(2){color: #333333;font-size: 14px;font-weight: bold;display: flex;align-items: center;text-align: right;flex: 1;justify-content: flex-end;}
    .sliderdown-item p:nth-of-type(2) span{color: #999999;font-size: 14px;padding-left: 5px;}
    .sliderdown-item p:nth-of-type(2) .icon-right{width: 16px;height: 16px;display: block;}

    /* 设置止损止盈里按钮 */
    .reviseBtn{padding: 15px 15px 30px 15px;display: flex;justify-content: space-between;align-items: center;}
    .reviseBtn p:nth-of-type(1){width: 48.3%;height: 44px;color: #333333;font-size: 16px;border-radius: 22px;background-color: #EEEEEE;text-align: center;line-height: 44px;font-weight: bold;}
    .reviseBtn p:nth-of-type(2){width: 48.3%;height: 44px;color: #FFFFFF;font-size: 16px;border-radius: 22px;background-image: linear-gradient(to right, #FF4F36,#FF6738);text-align: center;line-height: 44px;font-weight: bold;}


    /* 底部fixedbox */
    .pcFixedBox{border-top-left-radius: 12px;border-top-right-radius: 12px;background-color: #FFFFFF;position: fixed;bottom: 0;left: 0;right: 0;margin: 0 auto;z-index: 888;}
    .pcFixedBox .title{text-align: center;padding: 17.67px 0 20.33px 0;color: #333333;font-size: 16px;display: flex;justify-content: center;font-weight: bold;}
    .pcFixedBox .title img{width: 24px;height: 24px;display: block;position: absolute;top: 17px;left: 12px;}
    .pcFixedBox .content{padding: 13.33px 0 14.33px 0;background-color: #F8F8F8;margin: 0 12px auto;}
    .pcFixedBox .content .top{padding: 0 12px 13.33px 12px;display: flex;justify-content: space-between;align-items: center;}
    .pcFixedBox .content .top p:nth-of-type(1){display: flex;justify-content: flex-start;align-items: center;}
    .pcFixedBox .content .top p:nth-of-type(1) span:nth-of-type(1){width: 36px;height: 18px;display: flex;justify-content: center;align-items: center;color: #FFFFFF;font-size: 12px;background-color: #17CF84;margin-right: 6px;border-radius: 9px;}
    .pcFixedBox .content .top p:nth-of-type(1) span:nth-of-type(2){margin-right: 9.33px;font-size: 16px;font-weight: bold;color: #333333;}
    .pcFixedBox .content .top p:nth-of-type(1) span:nth-of-type(3){font-size: 16px;font-weight: bold;color: #333333;}
    .pcFixedBox .content .top p:nth-of-type(2){font-size: 16px;color: #FF6738;font-weight: bold;}
    .pcFixedBox .content ul{display: flex;justify-content: flex-start;align-items: center;margin: 0 12px auto;}
    .pcFixedBox .content ul .left{width: 30%;}
    .pcFixedBox .content ul .main{width: 30%;}
    .pcFixedBox .content ul .right{width: 30%;}
    .pcFixedBox .content ul li{width: 100%; display: flex;align-items: center;font-size: 10px;margin-top: 10px;}
    .pcFixedBox .content ul li:nth-of-type(1),.num ul li:nth-of-type(2){margin: 0;}
    .pcFixedBox .content ul li span{color: #999999;font-size: 10px;padding-left: 10px;}
    .pcFixedBox .content ul li span:nth-of-type(2){padding-left: 9.67px;color: #333333;}
    .fiexbottom{display: flex;justify-content: space-between;align-items: center;margin: 0 12px auto;padding: 15px 0;border-bottom: 1px solid #cccccc;}
    .fiexbottom p:nth-of-type(1){font-size: 14px;color: #333333;}
    .fiexbottom p:nth-of-type(2){display: flex;justify-content: space-between;align-items: center;width: 55%;padding: 0 10px;}
    .fiexbottom p:nth-of-type(2) input{width: 40%;text-align: center;outline: none;border: none;font-size: 16px;color: #333333;font-weight: bold;}
    .fiexbottom p:nth-of-type(2) img{width: 24px;height: 24px;display: block;}
    .fiexbottom p:nth-of-type(3){display: flex;justify-content: space-between;align-items: center;font-size: 12px;color: #BBBBBB;}
    /* .fiexbottom p:nth-of-type(3) span:nth-of-type(1){display: block;width: 36px;height: 18px;border-radius: 9px;border: 1px solid #cccccc;text-align: center;line-height: 18px;} */
    .fiexbottom p:nth-of-type(3) span:nth-of-type(2){width: 36px;height: 18px;margin-left: 5px;}
    .pcFixedBox .btn{height: 40px;margin: 15px 12px 35px 12px; border-radius: 20px;background-image: linear-gradient(to right, #FF4F36, #FF6738);display: flex;justify-content: center;align-items: center;color: #FFFFFF;font-weight: bold;font-size: 16px;}

     /* 无订单 */
     .nomsg{font-size: 14px;color: #BBBBBB;text-align: center;margin-top: 10px;padding-bottom: 80px;}
     .nomsg img{width: 240ox;height: 120px;margin: 0 auto;display: block;}
     .nomsg p{border-radius: 12px;color: #FFFFFF;display: flex;justify-content: center;align-items: center;background-image: linear-gradient(to right, #FF6738, #FF4F36);height: 34px;width: 60px;margin: 15px auto;}

     .active{display: block;width: 36px;height: 18px;border-radius: 9px;color: #FF4F36; text-align: center;line-height: 18px;border: none;background-color: #FFEDEA;}
     .actived{display: block;width: 36px;height: 18px;border-radius: 9px;border: 1px solid #cccccc;text-align: center;line-height: 18px;}

     .mainactive{display: none;}

    .numbox{display: block;}
    .numbox ul{padding: 13.33px 0 14.33px 0px;background-color: #F8F8F8;margin-top:11.67px;display: flex;justify-content: flex-start;align-items: center;flex-wrap: wrap;}
    .numbox ul li{width: 142px; display: flex;align-items: center;font-size: 14px;margin-top: 10px;}
    .numbox ul li:nth-of-type(1),.num ul li:nth-of-type(2){margin: 0;}
    .numbox ul li span{color: #999999;font-size: 14px;padding-left: 10px;}
    .numbox ul li span:nth-of-type(2){padding-left: 9.67px;color: #333333;}

    /* 加载loading */
    .isloginTips{width: 150px;border-radius: 9px;background: rgba(0, 0, 0, 0.6);position: fixed;left: 0;right: 0;top: 40%;z-index: 888;color: #FFFFFF;font-weight: bold;font-size: 14px;text-align: center;line-height: 60px;margin: 0 auto;display: flex;justify-content: center;align-items: center;flex-direction: column;}
    .isloginTips p{height: 50px;display: flex;align-items: center;}
    .isloginTips img{width: 40px;height: 40px;display: block;margin-top: 20px;animation:loading 0.75s linear infinite forwards;}
    @keyframes loading {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    /* faq盒子 */
    .faq{width: 300px;border-radius: 12px;background-color: #FFFFFF;position: fixed;top: 40%;left: 0;right: 0;z-index: 888;margin: 0 auto;}
    .faq-title{padding: 17.67px 0 20.33px 0;color: #333333;font-weight: bold;font-size: 16px;text-align: center;}
    .faq-content{border-bottom: 1px solid #F5F5F5;padding: 0 20px 20.33px 20px;line-height: 24px;}
    .faq-bottom{padding: 17.33px 0;text-align: center;color: #FF4F36;font-size: 16px;font-weight: bold;}

    /*通过fixed固定mescroll的高度*/
	.mescroll {position: fixed;top: 82px;bottom: 0;height: auto;z-index: 885;}
</style>


// WEBPACK FOOTER //
// src/pages/hold.vue